import { useCallback, useContext } from 'react';
// eslint-disable-next-line @alf/loop-deps
import { useStatuses } from '@namespace/account';
import { useGeneralRoutes } from '@namespace/cms';
import { useNavigate } from '@namespace/router';
import { closeNotificationAction } from '../../../../store/actions';
import { NotificationContext } from '../../../../store/context';

export const useWithdrawalLimitToast = () => {
  const [{ notificationDispatch }] = useContext(NotificationContext);

  const { isPassportInVerification } = useStatuses();
  const { profilePage } = useGeneralRoutes();
  const navigate = useNavigate();

  const onClose = useCallback(() => {
    notificationDispatch(closeNotificationAction());
  }, [notificationDispatch]);

  const onClick = useCallback(() => {
    navigate(profilePage);
    onClose();
  }, [navigate, onClose, profilePage]);

  return {
    onClose,
    onClick,
    isPassportInVerification
  };
};
